import http from 'hub-http/clients/apiClient';
const root = 'product-updates/v3/rollout-product-updates/new-to-you';
export const getNewToYouTimestamp = () => http.get(`${root}`);
export const updateNewToYouTimestamp = () => http.post(`${root}`);